import redirectToURL from './redirectToURL'

const redirectToURLForNativeFacebookLogIn = (redirectURLString) => {
  const redirectURL = new URL(redirectURLString)

  redirectURL.searchParams.append('native_log_in_provider', 'facebook.com')

  redirectToURL(redirectURL.href)
}

export default redirectToURLForNativeFacebookLogIn
